import PageHero from "@/components/PageHero";
import { IMAGES, CHAIRMAN_MESSAGE } from "@/lib/site";
import { Quote } from "lucide-react";

export default function ChairmanPage() {
  const paragraphs = CHAIRMAN_MESSAGE.split("\n\n");

  return (
    <div data-testid="chairman-page">
      <PageHero eyebrow="CHAIRMAN'S MESSAGE" title="From the Chairman & Founder" subtitle="Leadership rooted in vision, values and an unwavering commitment to every child's future." />

      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-5 gap-12 items-start">
          {/* Photo block — full size, prominent */}
          <div className="md:col-span-2 md:sticky md:top-28">
            <div className="relative">
              <div className="absolute -inset-4 bg-gold/20 rounded-3xl blur-3xl" />
              <img
                src={IMAGES.chairman}
                alt="Chairman & Founder, Royal English Medium High School"
                className="relative rounded-3xl shadow-2xl w-full aspect-[3/4] object-cover border-4 border-white"
                data-testid="chairman-photo"
              />
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-gold text-royal-dark px-6 py-2 rounded-full shadow-xl text-xs font-bold tracking-[0.25em] whitespace-nowrap">
                CHAIRMAN & FOUNDER
              </div>
            </div>
            <div className="mt-10 text-center">
              <h3 className="font-serif-display text-2xl font-bold text-royal">Royal Education Society (R.)</h3>
              <p className="text-gold font-semibold tracking-wide mt-1">Founder & Chairman</p>
              <p className="text-gray-500 text-sm mt-1">Royal English Medium High School, Chikmagalur</p>
            </div>
          </div>

          {/* Message block */}
          <div className="md:col-span-3">
            <div className="bg-[#f7f7f7] border border-gray-100 rounded-3xl p-8 md:p-10 relative">
              <Quote className="text-gold absolute top-6 right-6" size={36} />
              <p className="text-xs tracking-[0.3em] text-gold font-bold">A MESSAGE FROM THE CHAIRMAN</p>
              <h2 className="font-serif-display text-3xl md:text-4xl font-bold text-royal mt-3 leading-tight">
                Building Tomorrow's Leaders, Today.
              </h2>
              <div className="gold-divider" />
              <div className="space-y-4 mt-6 text-gray-700 leading-relaxed text-[15px] md:text-base">
                {paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              <div className="mt-8 border-t border-gold/30 pt-5">
                <p className="font-serif-display text-2xl font-bold text-royal">— Chairman / Founder</p>
                <p className="text-sm text-gray-600 italic">Royal English Medium High School, Chikmagalur</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
